/**
 * Views API
 */

import type { View, ListTasksResponse } from '../types';
import { fetchApi } from './fetch';

export async function getViews(): Promise<View[]> {
  const data = await fetchApi<{ data: View[]; total: number; limit: number; skip: number }>('/views');
  return data.data;
}

export async function getView(slug: string): Promise<View> {
  return fetchApi<View>(`/views/${slug}`);
}

export async function getViewTasks(
  slug: string,
  options?: { limit?: number; offset?: number; includeCompleted?: boolean }
): Promise<ListTasksResponse> {
  const params = new URLSearchParams();
  if (options?.limit) params.set('limit', String(options.limit));
  if (options?.offset) params.set('offset', String(options.offset));
  if (options?.includeCompleted) params.set('includeCompleted', 'true');
  const query = params.toString();
  const endpoint = `/views/${slug}/tasks${query ? `?${query}` : ''}`;
  return fetchApi<ListTasksResponse>(endpoint);
}

export async function createView(data: {
  name: string;
  slug?: string;
  filterConfig: {
    priority?: number[];
    categories?: string[];
    projectId?: string;
    dueWithin?: 'today' | '7d' | '14d' | '30d';
    overdue?: boolean;
    completed?: boolean;
    limit?: number;
    search?: string;
  };
}): Promise<View> {
  return fetchApi<View>('/views', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function deleteView(slug: string): Promise<void> {
  await fetchApi<void>(`/views/${slug}`, { method: 'DELETE' });
}

export async function updateView(
  slug: string,
  updates: {
    name?: string;
    filterConfig?: {
      priority?: number[];
      categories?: string[];
      projectId?: string;
      dueWithin?: 'today' | '7d' | '14d' | '30d';
      overdue?: boolean;
      completed?: boolean;
      limit?: number;
      search?: string;
      icon?: string;
    };
    orderIndex?: number;
  }
): Promise<View> {
  return fetchApi<View>(`/views/${slug}`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });
}
